import React, { useState, useEffect } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faLongArrowAltUp,
  faLongArrowAltDown,
} from "@fortawesome/free-solid-svg-icons";

import IndicatorMain from "../../components/partials/IndicatorMain";
import ParametersTables from "../../components/partials/ParametersTables";
import WSTable from "../../components/partials/WSTable";

import "../../styles/workshop_infos.css";

const Synthesis = (props) => {
    const { indicators, computedDatas, results} = props;
  return (
        <>
          {indicators && (
            <div className="main_container result-box">
              <h2 className="container_title">Résultats</h2>

              <h3 className="container_secondary_title">Impacts généraux</h3>

              {/* BADGES */}
              <div className="indicator_box main-box flex-item">
                {indicators
                  .filter((v) => v.impactGnl === "1")
                  .map((indicator, i) => (
                    <IndicatorMain
                      key={i}
                      icon={i}
                      value={indicator.value}
                      unit={indicator.unit}
                      description={indicator.name}
                    />
                  ))}
              </div>

              {/* TABLE */}
              <WSTable table={results.aggregator.impactGnlTable} numberDisplayed="all" />

              <h3 className="container_secondary_title">Impacts sur le territoire</h3>

              {/* BADGES */}
              <div className="indicator_box secondary-box flex-item">
                {indicators
                  .filter((v) => v.impactLcl === "1")
                  .map((indicator,i) => (
                    <IndicatorMain
                      key={i}
                      value={indicator.value}
                      unit={indicator.unit}
                      description={indicator.name}
                    />
                  ))}
              </div>
            </div>
          )}

          {indicators && (
            <div className="main_container">
              <h2 className="container_title">Paramètres clés</h2>

              <h3 className="container_secondary_title">Contributions</h3>

              <div className="param-box flex-item acenter jbetween">
                <ParametersTables
                  title={
                    <h4 className="tab-btn active">
                      <FontAwesomeIcon icon={faLongArrowAltUp} />
                      Les plus utilisés
                    </h4>
                  }
                  table={computedDatas.nbModifTable}
                  numberDisplayed={3}
                />
                <ParametersTables
                  title={
                    <h4 className="tab-btn active">
                      <FontAwesomeIcon icon={faLongArrowAltDown} />
                      Les moins utilisés
                    </h4>
                  }
                  table={computedDatas.nbModifRevTable}
                  numberDisplayed={3}
                />
              </div>

              <h3 className="container_secondary_title">Consensus</h3>

              <div className="param-box flex-item acenter jbetween">
                <ParametersTables
                  title={
                    <h4 className="tab-btn active">
                      <FontAwesomeIcon icon={faLongArrowAltUp} />
                      Les plus consensuels
                    </h4>
                  }
                  table={computedDatas.consensusRevTable}
                  numberDisplayed={3}
                />
                <ParametersTables
                  title={
                    <h4 className="tab-btn active">
                      <FontAwesomeIcon icon={faLongArrowAltDown} />
                      Les moins consensuels
                    </h4>
                  }
                  table={computedDatas.consensusTable}
                  numberDisplayed={3}
                />
              </div>
            </div>
          )}
        </> 
  )
}

export default Synthesis